export const flipTransition = { duration: 0.1, ease: 'easeInOut' };
//# sourceMappingURL=transitions.js.map